import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[toUpperCase]',
})
export class UppercaseDirective {
  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    let input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    this.control.control?.setValue(input.value);
  }

  @HostListener('blur', ['$event']) onBlur(event: InputEvent) {
    let input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    this.control.control?.setValue(input.value);
  }

  constructor(private control:NgControl) {
  }
}